import { render, staticRenderFns } from "./MultipleOptionsQuestion.vue?vue&type=template&id=3f2f7cd6&scoped=true&"
import script from "./MultipleOptionsQuestion.vue?vue&type=script&lang=js&"
export * from "./MultipleOptionsQuestion.vue?vue&type=script&lang=js&"
import style0 from "./MultipleOptionsQuestion.vue?vue&type=style&index=0&id=3f2f7cd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2f7cd6",
  null
  
)

export default component.exports